import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "color-fill",
  "use": "color-fill-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 17\" id=\"color-fill\"><path d=\"M13.56 8.94 4.62 0 3.21 1.41l2.38 2.38L.44 8.94a1.49 1.49 0 0 0 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM2.21 10 7 5.21 11.79 10zM16 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol